import { useEffect, useState } from 'react';
import { makeStyles, IconButton, Menu, MenuItem, FormControlLabel, Checkbox } from "@material-ui/core";
import UtilService from '../../../../../../../helper/service';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ImmersionModal from '../../../../../../atoms/modals/commonModal';
import clsx from 'clsx'
import { excludeParticipants, getExcludedParticipants, removeAllGraph, removeParticipantFromAll, setLoading } from '../../../../../../../store/actions/creator/analysis';
import { useDispatch, useSelector } from "react-redux";
import AnalysisScoreIcon from '../../../../../../atoms/creator/analyzeScoreIcon';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import { useStylesTooltip } from "../../../../../../../config/theme";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'solid',
    borderRadius: 20,
    position: 'relative',
    borderWidth: 4,
    height: 200,
  },
  overallPanel: {
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 20,
    marginLeft: 4,
    width: 50,
    '& span': {
      fontSize: 33,
      fontFamily: 'Spartan-bold'
    }
  },
  participant: {
    fontSize: 23,
    fontFamily: 'Spartan-bold'
  },
  contextLabel: {
    fontSize: 15,
    fontFamily: 'Spartan-semibold',
    textTransform: 'uppercase',
    letterSpacing: 1.8
  },
  contextPanel: {
    marginTop: 18,
    marginLeft: 10,
    left: 50
  },
  score: {
    top: 0,
    position: 'absolute',
    display: 'flex',
    right: 0,
    flexDirection: 'row-reverse'
  },
  menuBox: {
    position: 'absolute',
    right: 2,
    top: 8,
  },
  iconBtn: {
    width: 40,
    borderRadius: 10,
    marginLeft: 20,
    '&:hover': {
      background: '#017AEF14'
    },
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 20,
    marginLeft: 20,
  },
  menuItem: {
    padding: 0
  },
  menuText: {
    color: '#697683',
    fontSize: 12,
    fontFamily: 'roboto-regular'
  },
  icon: {
    borderRadius: 3,
    width: 27,
    height: 28,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/unchecked.svg\")",
    marginRight: 10
  },
  checkedIcon: {
    marginRight: 10,
    '&:before': {
      display: 'block',
      width: 31.5,
      height: 28,
      backgroundImage: "url(\"/assets/icons/checked.svg\")",
      content: '""',
    },
  },
  checkbox: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  label: {
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  leftMode: {
    left: 0,
    flexDirection: 'row'
  },
  rightMode: {
    right: 0,
    flexDirection: 'row'
  },
  leftPane: {
    position: 'absolute',
    width: 56,
    height: 192,
    left: 0,
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20
  },
  rightPane: {
    position: 'absolute',
    width: 56,
    height: 192,
    right: 0,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20
  }
}));

function ScorePane(props: any) {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const dispatch = useDispatch();

  const {
    immersionData,
    participant,
    graphWidth,
    safetyOverall,
    sessionStatus,
    overall,
    realTimeScores,
    marginBottom,
    overview
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [removeModal, setRemoveModal] = useState(false);
  const [restoreModal, setRestoreModal] = useState(false);
  const [removeChecked, setRemoveChecked] = useState(false);
  const [removeLoading, setRemoveLoading] = useState<boolean>(false);
  const [restoreLoading, setRestoreLoading] = useState<boolean>(false);

  const [stimulusOverallIndex, setStimulusOverallIndex] = useState(0);
  const [stimulusColorIndex, setStimulusColorIndex] = useState('Gray');
  const apolloClient = useSelector((state: any) => state.apolloClient)
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const { realTimeGraphType, cliped, currentSession, stimulus, settings, analyseStart, all, identifiers, excludedParticipants } = useSelector((state: any) => state.analysis);
  const { videoPlayed, videoStopped, videoPopIn, videoRemoved } = settings;
  const { session_type, session_status, session_code } = currentSession;

  let overall_index = immersionData ? immersionData.overall_index : safetyOverall.safety_index
  let overall_color_indicator = immersionData ? immersionData.overall_color_indicator : safetyOverall.color_indicator
  let overall_context_indicator = immersionData ? immersionData.overall_context_indicator : safetyOverall.context_indicator

  if (participant === 'All' && cliped && cliped.score) {
    overall_index = immersionData ? cliped.score.immersion.immersion_index : cliped.score.safety.safety_index
    overall_color_indicator = immersionData ? cliped.score.immersion.color_indicator : cliped.score.safety.color_indicator
    overall_context_indicator = immersionData ? cliped.score.immersion.context_indicator : cliped.score.safety.context_indicator
  }

  if (sessionStatus === 'LIVE' && session_type === 'MODERATED') {
    if (realTimeGraphType === 1) {
      overall_index = realTimeScores ? realTimeScores['immersion_index'] : 0;
      overall_color_indicator = realTimeScores ? realTimeScores['color_indicator'] : 'Red';
      overall_context_indicator = realTimeScores ? realTimeScores['context_indicator'] : '';
    } else {
      if (overall) {
        overall_index = overall.immersion_index;
        overall_color_indicator = overall.color_indicator;
        overall_context_indicator = overall.context_indicator;
      }
    }
  }

  useEffect(() => {
    if (immersionData && (session_status === 'COMPLETED' || (session_status === 'LIVE' && session_type === 'ASYNC'))) {
      getImmersionData();
    }
  }, [videoPlayed, videoPopIn, all.length]);

  const getImmersionData = async () => {

    if (!(immersionData.data && immersionData.data.length > 0)) {
      return;
    }

    const curTime = (stimulus && (!cliped || cliped && (cliped.start_clip - analyseStart < stimulus?.stimulus_video_length)) && !videoRemoved)
      ? Math.floor(stimulus.stimulus_video_length * videoPlayed)
      : Math.round(videoPopIn);

    const epoch0 = session_type === 'MODERATED' ? (cliped ? cliped.start_clip : analyseStart) * 1000 : UtilService.getLocalEpoch2(immersionData.data[0].time_stamp) * 1000;

    const immersion = immersionData.data.find((item: any) => {
      const epoch = UtilService.getLocalEpoch2(item.time_stamp) * 1000;
      const immersionTime = cliped ? (cliped.start_clip - (session_type === 'MODERATED' ? analyseStart : 0)) + (epoch - epoch0) / 1000 : (epoch - epoch0) / 1000;
      return immersionTime === curTime;
    })

    if (immersion) {
      setStimulusOverallIndex(immersion.immersion_index);
      setStimulusColorIndex(UtilService.getColorFromImmersion(immersion));
    } else {
      setStimulusOverallIndex(1);
      setStimulusColorIndex('gray');
    }
  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onRemoveExcluded = () => {

    const request = {
      session_code: currentSessionCode,
      exclude: true,
      identifier: [participant]
    }

    setRemoveLoading(true)

    dispatch(excludeParticipants(apolloClient.client, request, () => {
      setRemoveLoading(false)
      setRemoveModal(false)
      setAnchorEl(null);
      dispatch(removeParticipantFromAll([participant]));
      dispatch(getExcludedParticipants(apolloClient.client, currentSessionCode))

      if (identifiers.length === excludedParticipants.length + 1) {
        dispatch(removeAllGraph())
      } else {
        dispatch(setLoading(true))
      }
    }))
  }

  
	const onRestoreExcluded = () => {

		const request = {
			session_code,
			exclude: false,
			identifier: [participant]
		}

		setRestoreLoading(true)

		dispatch(excludeParticipants(apolloClient.client, request, () => {
			setRestoreLoading(false)
			setRestoreModal(false)
			dispatch(getExcludedParticipants(apolloClient.client, session_code))
			dispatch(setLoading(true))
		}))
	}

  const videoStoppedAvailable = !videoStopped || (videoStopped && session_type === 'MODERATED' && videoPopIn + (cliped ? analyseStart - cliped.start_clip : 0) > 1)

  return (
    <div
      className={classes.root}
      style={{
        width: graphWidth + 120,
        borderColor: UtilService.refactorGraphColor(overall_index > 1 ? overall_color_indicator : 'gray'),
        marginBottom: marginBottom ? marginBottom : 65
      }}
    >
      <div className={classes.leftPane} style={{ background: overview ? '#fff' : '#f0f0f0' }} />
      <div className={classes.rightPane} style={{ background: overview ? '#fff' : '#f0f0f0' }} />
      <div
        className={clsx(classes.score,
          (sessionStatus === 'COMPLETED' ||
            (sessionStatus === 'LIVE' && realTimeGraphType === 0) ||
            session_type === 'ASYNC'
          ) && classes.leftMode)}

      >
        {(!videoStoppedAvailable && !overview) ? <div
          className={classes.overallPanel}
          style={{
            color: UtilService.refactorGraphColor(overall_index > 1 ? overall_color_indicator : 'gray'),
          }}
        >
          {(session_type === 'MODERATED' && sessionStatus === 'LIVE' && realTimeGraphType === 1) ? (
            <Tooltip classes={tooltipClasses} title="Second-by-Second Immersion" placement="bottom" arrow>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <AnalysisScoreIcon color={overall_index > 1 ? overall_color_indicator : 'gray'} type={immersionData ? 'immersion' : 'safety'} />
                <span>{overall_index > 1 ? overall_index : '--'}</span>
              </div>
            </Tooltip>
          ) : (
            <>
              <AnalysisScoreIcon color={overall_index > 1 ? overall_color_indicator : 'gray'} type={immersionData ? 'immersion' : 'safety'} />
              <span>{overall_index > 1 ? overall_index : '--'}</span>
            </>
          )}
        </div> : <div className={classes.overallPanel} />}

        {!overview && <div
          className={classes.contextPanel}
          style={{ color: UtilService.refactorGraphColor(overall_index > 1 ? overall_color_indicator : 'gray') }}
        >
          <div className={classes.participant}>{participant === 'All' ? 'All Participants' : participant}</div>
          <div className={classes.contextLabel}>{overall_context_indicator}</div>
        </div>}

      </div>

      {
        immersionData && videoStoppedAvailable && !overview &&
        <div className={clsx(classes.score,
          (sessionStatus === 'COMPLETED'
          ) && classes.rightMode)}>
          <div
            className={classes.overallPanel}
            style={{ color: UtilService.refactorGraphColor(stimulusOverallIndex > 1 ? stimulusColorIndex : 'gray') }}
          >
            <Tooltip classes={tooltipClasses} title="Second-by-Second Immersion" placement="bottom" arrow>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <AnalysisScoreIcon color={stimulusOverallIndex > 1 ? stimulusColorIndex : 'gray'} type={'immersion'} />
                <span>{stimulusOverallIndex > 1 ? stimulusOverallIndex : '--'}</span>
              </div>
            </Tooltip>
          </div>
        </div>
      }

      {
        participant !== 'All' && sessionStatus !== 'LIVE' &&
        <div>
          <div className={classes.menuBox}>
            <IconButton
              className={classes.iconBtn}
              color="primary"
              size='small'
              disableRipple
              onClick={handleClick}
            >
              <MoreVertIcon style={{ color: 'gray' }} />
            </IconButton>
          </div>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            elevation={2}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            style={{ marginTop: 45 }}
          >
            {!excludedParticipants.includes(participant) && <MenuItem
              onClick={() => setRemoveModal(true)}
              className={classes.menuText}
            >
              Remove
            </MenuItem>}

            {excludedParticipants.includes(participant) && <MenuItem
              onClick={() => {
                setRestoreModal(true);

              }}
              className={classes.menuText}
            >
              Restore
            </MenuItem>}
          </Menu>
        </div>
      }

      <ImmersionModal
        open={removeModal}
        title={'Are you sure ?'}
        description={'Removing this Participant’s measurement will adjust your aggregate results. We only recommend removing if this participant’s data collection was corrupted.'}
        titleOK={'Yes, Remove This Measurement'}
        onClose={() => setRemoveModal(!removeModal)}
        additional={
          <FormControlLabel
            control={
              <Checkbox
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                className={classes.checkbox}
                checked={removeChecked}
                onChange={() => setRemoveChecked(!removeChecked)}
                name="remove"
                color="primary"
                style={{
                  transform: "scale(0.7)",
                }}
              />
            }
            label={<p className={classes.label}>Don’t ask this again in the future.</p>}
          />
        }
        onApply={onRemoveExcluded}
        loading={removeLoading}
      />

      <ImmersionModal
        open={restoreModal}
        title={'Are you sure ?'}
        description={'Viewing this Participant’s data requires restoring their data to the aggregate results, which will likely change the aggregate results you see in the platform.'}
        titleOK={'Yes, Restore This Participant’s Data'}
        onClose={() => setRestoreModal(!restoreModal)}
        onApply={onRestoreExcluded}
        loading={restoreLoading}
      />

    </div>
  );
}

export default ScorePane;